import type { ProtectionPresetSummary, ProtectionPresetsSelection } from '@tracedocuments/types';

import { apiFetch } from './fetch';

/**
 * Presets + the id that should be pre-selected for sending: explicit default from
 * `/send-defaults`, falling back to the preset flagged `isDefault`, then the system preset,
 * then the first one. Mirrors what the conversation composer needs before a send.
 */
export async function fetchProtectionPresetsSelection(): Promise<ProtectionPresetsSelection> {
  const [presetsRes, defaultsRes] = await Promise.all([
    apiFetch('/api/settings/protection-presets'),
    apiFetch('/api/settings/send-defaults'),
  ]);
  if (!presetsRes.ok) throw new Error('protection presets fetch failed');
  const presets = (await presetsRes.json()) as ProtectionPresetSummary[];

  let selectedPresetId = '';
  if (defaultsRes.ok) {
    const defaults = (await defaultsRes.json()) as { defaultProtectionPresetId: string | null };
    selectedPresetId = defaults.defaultProtectionPresetId ?? '';
  }
  if (!selectedPresetId) {
    selectedPresetId =
      presets.find((p) => p.isDefault)?.id ??
      presets.find((p) => p.isSystem)?.id ??
      presets[0]?.id ??
      '';
  }

  return {
    presets,
    selectedPresetId,
    missingDefaultPreset: presets.length === 0 || !selectedPresetId,
  };
}
